export const providerApprovals = {
  title: 'Provider Approvals',
  organizationLabel: 'Organization',
  selectOptionPlaceholder: 'Select an option...',
  selectedCount: (count: number) => `${count} Selected`,
  tabs: {
    scheduledForReview: 'Scheduled for Review',
    inReview: 'In Review',
    approved: 'Approved',
    rejected: 'Rejected',
    incomplete: 'Incomplete'
  },
  grid: {
    patientName: 'Patient Name',
    dateOfBirth: 'Date of Birth',
    phoneNumber: 'Phone number',
    zipcode: 'Zipcode',
    requestedOn: 'Requested On',
    approvedOn: 'Approved On',
    rejectedOn: 'Rejected On',
    scheduledOn: 'Scheduled On',
    statusUpdatedOn: 'Status Updated On',
    approvalMode: 'Approval Mode',
    providerNote: 'Provider Note',
    reSchedule: 'Re-Schedule'
  },
  dialogs: {
    providerNoteTitle: (patientName: string) => `Provider Note for ${patientName}`
  },
  snackbars: {
    failedToRetrieveReports: 'Failed to retrieve reports'
  }
} as const;
